import { useCallback } from "react";

import { useRouter } from "next/router";
import { customerAnalytics } from "../../utils/APICalls/APICalls";
import { getCookie } from "../../utils/CookieHelper";
import { COOKIE_ENUM, CUSTOMER_ANALYTICS_EVENT } from "../../utils/enums";
import envConfig from "../../utils/env.config";
import { AnalyticsExtraInfo } from "../../utils/types";

// save loyalty card event even if no token
const VISITOR_ANALYTICS_EVENTS: CUSTOMER_ANALYTICS_EVENT[] = [
  CUSTOMER_ANALYTICS_EVENT.LOYALTY_CARD_QR_VIEWED,
];

export const useCustomerAnalytics = () => {
  const router = useRouter();

  const franchise = router.query?.franchise;

  const addCustomerAnalytics = useCallback(
    async (
      event: CUSTOMER_ANALYTICS_EVENT,
      extraInfo?: AnalyticsExtraInfo,
      franchiseId?: number,
      franchiseSlug?: string
    ) => {
      const token = getCookie(COOKIE_ENUM.TOKEN);

      const routerFranchiseSlug = Array.isArray(franchise)
        ? franchise[0]
        : franchise;
      const effectiveFranchiseSlug = franchiseSlug || routerFranchiseSlug;

      const shouldSendToBackend =
        router.isReady && (token || VISITOR_ANALYTICS_EVENTS.includes(event));

      if (shouldSendToBackend) {
        try {
          await customerAnalytics(
            event,
            extraInfo,
            franchiseId,
            parseInt(envConfig.restaurantId!),
            effectiveFranchiseSlug
          );
        } catch (e) {
          console.debug(
            e,
            "Couldn't add the customer analysis " + event + " to db"
          );
        }
      } else if (!token) {
        console.log(
          "Was not able to add customer analytics, because TOKEN is not in cookies"
        );
      }
    },
    []
  );

  return addCustomerAnalytics;
};
